<template>
  <div></div>
</template>

<script>
export default {
  data: function () {
    return {};
  },

  created: function () {
    if (this.apidata.me.properties.tac_role === "rep") {
      this.$router.push("/tickets");
    }

    if (this.apidata.me.properties.tac_role === "manager") {
      this.$router.push("/reports");
    }
  },
};
</script>

<style scoped>
</style>
